// Central business info — used across the site for consistency.
// Update here only; every component references this single source.
export const BUSINESS = {
    name: "Empire Jamaica Fusion",
    short: "Empire",
    tagline: "Authentic Jamaican Fusion Restaurant",
    location: "Poughkeepsie, NY",
    address: {
        line1: "385 Main Street",
        line2: "Poughkeepsie, NY 12601",
        city: "Poughkeepsie",
        state: "NY",
        zip: "12601",
    },
    phoneDisplay: "(845) 849-0497",
    phoneLink: "tel:+18458490497",
    email: "Empirejamaicarestaurant@gmail.com",
    emailLink: "mailto:Empirejamaicarestaurant@gmail.com",
    rating: { stars: 4.8, reviews: 186, source: "Google" },
    hours: [
        { day: "Sun", hours: "Closed" },
        { day: "Mon", hours: "11:00 AM – 7:00 PM" },
        { day: "Tue", hours: "11:00 AM – 8:00 PM" },
        { day: "Wed", hours: "11:00 AM – 8:00 PM" },
        { day: "Thu", hours: "11:00 AM – 9:00 PM" },
        { day: "Fri", hours: "11:00 AM – 9:00 PM" },
        { day: "Sat", hours: "11:00 AM – 9:00 PM" },
    ],
    social: {
        instagram: {
            url: "https://instagram.com/empirejamaicafusionrestaurant",
            handle: "@empirejamaicafusionrestaurant",
        },
    },
    delivery: [
        { name: "Uber Eats", url: "#" },
        { name: "DoorDash", url: "#" },
        { name: "Grubhub", url: "#" },
    ],
};

export const NAV_LINKS = [
    { label: "Home", path: "/" },
    { label: "Menu", path: "/menu" },
    { label: "Catering", path: "/catering" },
    { label: "Private Events", path: "/private-events" },
    { label: "About", path: "/about" },
    { label: "Gallery", path: "/gallery" },
    { label: "Contact", path: "/contact" },
];
